import React from 'react';
import {
  BannerButtonBody,
  BannerButtonIcon,
  BannerButtonTitle,
  BannerButtonWrapper,
  BannerContainer,
  BannerImage,
  BannerText,
  BannerTitle
} from "../styles/banner";

function Banner({banner}) {
  const {title, style, text, bannerImage, button, clickable} = banner;
  const {value: titleValue, color: titleColor} = title;
  const containerStyles = {backgroundColor: style.backGroundColor, height: 'auto'};
  const textColorStyle = {color: text?.color};
  const titleColorStyle = {color: titleColor};

  const handleClickOnBanner = () => {
    if (clickable) {
      window.open(banner.webLink, '_blank')
    }
  };

  const handleClickOnButton = e => {
    e.stopPropagation();
    window.open(banner.webLink, '_blank')
  };

  return (
    <BannerContainer
      style={containerStyles}
      onClick={handleClickOnBanner}
      tabIndex="0"
      role="button"
    >
      <BannerTitle style={titleColorStyle}>
        {titleValue}
      </BannerTitle>
      {text && (
        <BannerText style={textColorStyle}>
          {text?.value}
        </BannerText>
      )}
      {button && (
        <BannerButtonWrapper>
          <BannerButtonBody
            onClick={handleClickOnButton}
            style={{backgroundColor: button?.backgroundColor}}
            tabIndex="0"
            role="button"
          >
            <BannerButtonTitle style={{color: button?.titleColor}}>
              {button?.title}
            </BannerButtonTitle>
            <BannerButtonIcon>
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                  <path d="M1 1h20v20H1z"/>
                  <path fill={button.titleColor}
                        d="M8.965 5 3 10.965l5.963 6.016 1.021-1.013-4.22-4.258h12.855v-1.438H5.726l4.256-4.255z"/>
                </g>
              </svg>
            </BannerButtonIcon>
          </BannerButtonBody>
        </BannerButtonWrapper>
      )}
      <BannerImage
        style={containerStyles}
        src={bannerImage}
        alt="img"
        width="160"
        height="160"
      />
    </BannerContainer>
  );
}


export default Banner;
